module.exports = __webpack_public_path__ + "img/adressMobile.618b44a8.jpg";